import React from "react";
import loaderImage from "../../../assets/images/animation_loader.gif";
import PropTypes from "prop-types";

const PageLoader = ({ isLoading }) => {
  return (
    <div
      className="animatedLoader h-100 "
      style={{
        display: isLoading ? "flex" : "none",
        position: isLoading ? "fixed" : "static",
      }}
    >
      <img
        alt="loader"
        loading="lazy"
        src={loaderImage}
        className="loaderImg"
      />
    </div>
  );
};

PageLoader.propTypes = {
  isLoading: PropTypes.bool,
};

export default PageLoader;
